import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  FormField,
  Box,
} from '@cloudscape-design/components';
import { Control, FieldErrors, UseFormWatch, UseFormResetField } from 'react-hook-form';
import { FormInput } from 'src/components/v2/FormInput';
import { FormTextEditor } from 'src/components/v2/FormTextEditor';
import { TranslationFormData } from 'src/validations/translationFormSchema';

interface TranslationSubQuestionsProps {
  control: Control<TranslationFormData>;
  errors: FieldErrors<TranslationFormData>;
  watch: UseFormWatch<TranslationFormData>;
  onTextEditorChange: (fieldName: string, value: string) => void;
  resetField: UseFormResetField<TranslationFormData>;
}

export const TranslationSubQuestions: React.FC<TranslationSubQuestionsProps> = ({
  control,
  errors,
  watch,
  onTextEditorChange,
  resetField,
}) => {
  const subQuestions = watch('subQuestions');

  return (
    <Container header={<Header variant="h2">Sub Questions</Header>}>
      {subQuestions && subQuestions.length > 0 ? (
        <SpaceBetween size="l">
          {subQuestions.map((subQuestion, index) => (
            <Container
              key={subQuestion.subQuestionId || index}
              header={<Header variant="h3">Sub Question {index + 1}</Header>}
            >
              <SpaceBetween size="l">
                <FormField
                  label="Title"
                  stretch
                  errorText={errors.subQuestions?.[index]?.title?.message}
                >
                  <FormInput control={control} name={`subQuestions.${index}.title`} />
                </FormField>

                <FormTextEditor
                  control={control}
                  name={`subQuestions.${index}.instruction`}
                  label="Instruction"
                  showFileUpload={false}
                  onChange={(value) =>
                    onTextEditorChange(`subQuestions.${index}.instruction`, value)
                  }
                  showRestoreButton={true}
                  onRestore={() => resetField(`subQuestions.${index}.instruction`)}
                />

                {subQuestion.taskDetails && (
                  <>
                    <FormField
                      label="Task Name"
                      stretch
                      errorText={
                        errors.subQuestions?.[index]?.taskDetails?.taskName?.message
                      }
                    >
                      <FormInput
                        control={control}
                        name={`subQuestions.${index}.taskDetails.taskName`}
                      />
                    </FormField>

                    <FormTextEditor
                      control={control}
                      name={`subQuestions.${index}.taskDetails.taskDescription`}
                      label="Task Description"
                      showFileUpload={false}
                      onChange={(value) =>
                        onTextEditorChange(
                          `subQuestions.${index}.taskDetails.taskDescription`,
                          value,
                        )
                      }
                      showRestoreButton={true}
                      onRestore={() =>
                        resetField(`subQuestions.${index}.taskDetails.taskDescription`)
                      }
                    />
                  </>
                )}
              </SpaceBetween>
            </Container>
          ))}
        </SpaceBetween>
      ) : (
        <Box textAlign="center" color="text-status-inactive" padding={{ vertical: 'l' }}>
          No sub questions for this question
        </Box>
      )}
    </Container>
  );
};
